export default (api, resource) => ({

    getAll: async ({ params, token }) => {
        const response = await api.get(`/${resource}?pagina=${params.pagina}&quantidade=${params.quantidade}`, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    getById: async ({ id, token }) => {
        const response = await api.get(`/${resource}/${id}`, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    create: async ({ propaganda, arquivo, token }) => {
        const formData = new FormData()
        formData.append('dados', new Blob([JSON.stringify(propaganda)], { type: 'application/json' }))
        formData.append('arquivo', arquivo)

        const response = await api.post(`/${resource}`, formData, {
            headers: {
                Authorization: token,
                'Content-Type': 'multipart/form-data'
            }
        })
        return { data: response.data }
    },

    update: async ({ id, propaganda, arquivo, token }) => {
        const formData = new FormData()
        formData.append('dados', new Blob([JSON.stringify(propaganda)], { type: 'application/json' }))
        if (arquivo) {
            formData.append('arquivo', arquivo)
        }

        const response = await api.put(`/${resource}/${id}`, formData, {
            headers: {
                Authorization: token,
                'Content-Type': 'multipart/form-data'
            }
        })
        return { data: response.data }
    },

    remove: async ({ id, token }) => {
        const response = await api.delete(`/${resource}/${id}`, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    }
})
